<template>
    <fieldset class="lni-c-form-control"
        :class="[{
            'lni-c-form-control--required': required,
        },
        this.class
        ]"
        :id="controlId"
    >
        <legend class="lni-c-form-control__label">{{ labelText }}</legend>
        <slot />
        <div class="lni-c-date">
        <label class="lni-u-visually-hidden" :for="'mm-' + controlId">Month, two digits</label>
        <input class="lni-c-date-month lni-c-form-control__input"
            type="tel"
            :maxlength="2"
            :id="'mm-' + controlId"
            v-on:change="handleErrorState"
            @input="onInput"
            placeholder="mm"
        >
        <label class="lni-u-visually-hidden" :for="'dd-' + controlId">Day, two digits</label>
        <input class="lni-c-date-day lni-c-form-control__input"
            type="tel"
            :maxlength="2"
            :id="'dd-' + controlId"
            v-on:change="handleErrorState"
            @input="onInput"
            placeholder="dd"
        >
        <label class="lni-u-visually-hidden" :for="'yyyy-' + controlId">Year, four digits</label>
        <input class="lni-c-date-year lni-c-form-control__input"
            type="tel"
            :maxlength="4"
            :id="'yyyy-' + controlId"
            v-on:change="handleErrorState"
            @input="onInput"
            placeholder="yyyy"
        >
        </div>
    </fieldset>
</template>

<script>
import framework from '../../framework';

/**
 *  The x-input-memorable-date component.
 *  @module components/x-input-memorable-date
 */


/**
 * The x-input-text is a memorable date input control with a label.
 * It can also display validation messages.
 */
export default {
    name: 'x-input-memorable-date',
    props: {
        dataLabelText: String,
    },
    mixins: [
        framework.mixins.abstractSingleValueInput,
    ],
    mounted() {
        this.initialize();
    },
    data() {
        return {
            componentValue: '',
        };
    },
    computed: {
        /**
         * The text for the label.
         * @returns {string} label text.
         */
        labelText() {
            return this.getAttribute('labelText', '');
        },
    },
    methods: {
        /**
         * Formats the value of the date from a change in one of the text boxes.
         * @param {object} event the input event.
         * @returns {void}
         */
        onInput(event) {
            // check to see if input is a number
            let result = (/^\d$/).test(event.data);

            // if not disallow that input and reset the value to what it previously was
            if (!result) {
                let newValue = parseInt(event.target.value);
                if (isNaN(newValue)) {
                    newValue = '';
                }
                // This is a bizarre hack.  If you don't set the value to some
                // other constant number, it will not take out the decimal point from the input.
                event.target.value = 1;
                event.target.value = newValue;
                return false;
            }

            let constructedDate = this.makeDateFromInputs();
            this.value = constructedDate && constructedDate !== 'invalid'
                ? constructedDate.toLocaleDateString('en-US')
                : '';

            // for month and day, move to next input after 2nd digit entered
            const charLength = 2;
            if (event.target.value.length === charLength) {
                this.moveToNextInput(event.target.className);
            }

            return true;
        },

        moveToNextInput(className) {
            if (className.includes('month')) {
                this.$el.querySelector('input.lni-c-date-day').focus();
            } else if (className.includes('day')) {
                this.$el.querySelector('input.lni-c-date-year').focus();
            }
        },

        /**
         * Gets the error information off of the input element(s)
         * @returns {void}
         */
        getErrorStateOffInputs() {
            let constructedDate = this.makeDateFromInputs();

            // an empty message means there is no error.
            let message = '';

            if (constructedDate === 'invalid') {
                // invalid input
                message = 'Please enter a valid date.';
            } else if (this.required && !constructedDate) {
                // required and no input in constructed date
                message = 'This date field is required.';
            }

            return this.createValidationPayload(message);
        },
        /**
         * Makes a date from the input element(s)
         * @returns {void}
         */
        makeDateFromInputs() {
            let month = this.$el.querySelector('input.lni-c-date-month').value;
            let day = this.$el.querySelector('input.lni-c-date-day').value;
            let year = this.$el.querySelector('input.lni-c-date-year').value;

            // no input
            if (!(month && day && year)) {
                return '';
            }

            let constructedDate = new Date(year, month - 1, day);
            if (isNaN(Date.parse(constructedDate.toString()))) {
                return 'invalid';
            }

            return constructedDate;
        },
        /**
         * Put the values onto the Html Inputs
         * @returns {void}
         */
        initializeHtmlInputs() {
            if (this.componentValue) {
                const dateValue = new Date(this.componentValue);
                let month = dateValue.getMonth() + 1;
                let day = dateValue.getDate();
                let year = dateValue.getFullYear();
                this.$el.querySelector('input.lni-c-date-month').value = month;
                this.$el.querySelector('input.lni-c-date-day').value = day;
                this.$el.querySelector('input.lni-c-date-year').value = year;
            }
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import
  "../../styles/settings",
  "input-memorable-date";
</style>



// WEBPACK FOOTER //
// source/components/x-input-memorable-date/x-input-memorable-date.vue